import React from 'react';
import styles from './TextEffects3d.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';

export type TextEffects3dProps = TextEffectsSharedProps;

const TextEffects3d: React.FC<TextEffectsSharedProps> = props => {
  const { text } = props;

  return (
    <TextEffectsShared {...props}>
      <div className={styles.container} data-testid={TestIds.viewer.container}>
        <div data-testid={TestIds.viewer.text}>{text}</div>
      </div>
    </TextEffectsShared>
  );
};

export default TextEffects3d;
